// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"7348fedd","180":"7348fedd","237":"7348fedd","286":"78275b93","467":"7348fedd","535":"ce63fb3c","595":"92dc08e8","610":"fedde99b","718":"7348fedd"}[chunkId] + ".chunk.css";
};